import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNVaccine } from 'src/app/models/cnvaccine';
import { VaccinationService } from 'src/app/services/vaccination.service';

@ManageType('AdminVaccinationManagementDialogComponent')
@Component({
  selector: 'app-admin-vaccination-management-dialog',
  templateUrl: './admin-vaccination-management-dialog.component.html',
  styleUrls: ['./admin-vaccination-management-dialog.component.scss']
})
export class AdminVaccinationManagementDialogComponent implements OnInit {

  public vaccines: CNVaccine[] = [];
  public selectedVaccine = new CNVaccine();

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<AdminVaccinationManagementDialogComponent>,
              private vaccination: VaccinationService) { }

  ngOnInit(): void {
    this.vaccination.vaccines.subscribe(vaccines => {
      this.vaccines = vaccines;
    });
  }

  public addVaccine(): void {

  }

  public select(vaccine: CNVaccine): void {
    this.selectedVaccine = vaccine;
  }

  close() {
    this.dialogRef.close();
  }

}
